import React from 'react';
import { Badge, Button, Card, Col, Icon, Row, Tabs, Table } from 'antd';

import SupplierSearch from './search';

const { Column } = Table;
// const { TabPane } = Tabs;

class SupplierTable extends React.Component{
	render(){

		let { data, loading } = this.props;
		const { activeFilterCategory, filter,  } = this.state;

		data = data || [];

		let _data

		let filterRegex = new RegExp(filter, 'gi');
		
		if(activeFilterCategory === 'all') {

			_data = data.filter( d => {
				
				if( filterRegex.test(d.details.companyName) ){
					return true;
				}

				if( filterRegex.test(d.details.email) ){
					return true;
				}

				return false;

			});

		} else if(activeFilterCategory === 'verifiedActive') {

			_data = data.filter( d => {

				let regexMatch = false;

				if( filterRegex.test(d.details.companyName) ){
					regexMatch = true;
				}

				if( filterRegex.test(d.details.email) ){
					regexMatch = true;
				}

				if( !regexMatch ) return false;

				const { verification } = d;
				return (verification && verification.companyProfile && verification.bankInfo && verification.companyProfile.approve && verification.bankInfo.approve && d.shop.active)
			});

		} else if(activeFilterCategory === 'notVerified') {
			_data = data.filter(d => {

				let regexMatch = false;

				if( filterRegex.test(d.details.companyName) ){
					regexMatch = true;
				}

				if( filterRegex.test(d.details.email) ){
					regexMatch = true;
				}

				if( !regexMatch ) return false;

				const { verification } = d;
				return (verification && verification.companyProfile && verification.bankInfo && !verification.companyProfile.approve && !verification.bankInfo.approve && verification.companyProfile.document && verification.bankInfo.document)
			})

		} else if(activeFilterCategory === 'docsNotSubmitted') {
			_data = data.filter( d => {
				
				let regexMatch = false;

				if( filterRegex.test(d.details.companyName) ){
					regexMatch = true;
				}

				if( filterRegex.test(d.details.email) ){
					regexMatch = true;
				}

				if( !regexMatch ) return false;

				const { verification } = d;
				return (!verification || !verification.companyProfile || !verification.bankInfo || !verification.companyProfile.document || !verification.bankInfo.document)
			})

		} else if(activeFilterCategory === 'disabledShops') {
			_data = data.filter( d => {

				let regexMatch = false;

				if( filterRegex.test(d.details.companyName) ){
					regexMatch = true;
				}

				if( filterRegex.test(d.details.email) ){
					regexMatch = true;
				}

				if( !regexMatch ) return false;

				return !d.shop || !d.shop.active;
			});

		} else if(activeFilterCategory === 'flaggedForDelete') {
			_data = data.filter( d => {

				let regexMatch = false;

				if( filterRegex.test(d.details.companyName) ){
					regexMatch = true;
				}

				if( filterRegex.test(d.details.email) ){
					regexMatch = true;
				}

				if( !regexMatch ) return false;

				return d.flaggedForDelete
			});

		}else {
			_data = data;
		} 

		// console.log("active data =  " ,_data)

		if(_data) {
			return (
			
				<Card 
					loading={loading}
					title={<div>
							<Row>
								<Col span={4}>
									Supplier List
								</Col>
	
								{(this.props.data)?
									<Col span={4}>
										<SupplierSearch 
											suppliers={data} 
											updateFilter={this.updateFilterParam}/>
									</Col>
								:
								''
								}
								
							</Row>
						</div>} 
					extra={
					<Button onClick={this.props.handleClickAddSupplier}>
						<Icon type="plus-circle-o" />
						 Ghost Supplier
					</Button>
	
				} >
	
					<Tabs 
						defaultActiveKey="all" 
						onChange={this.updateFilter}
						// defaultActiveKey={this.state.activeFilterCategory}
						>    
						<Tabs.TabPane 
							tab={
								<span>
									All suppliers <Badge
										overflowCount={5000} 
										count={data.length} 
										style={{ 
											backgroundColor: '#fff',
											color: '#000000a8',
											boxShadow: '0 0 0 1px rgb(181, 181, 181) inset' 
										}}
										showZero 
									/>
								</span>
							}
							key="all" >
							
						</Tabs.TabPane>
						
						<Tabs.TabPane 
							tab={
								<span>
									Verified & Active  <Badge
										overflowCount={5000} 
										count={data.filter( d => {
												const { verification } = d;
												return (verification && verification.companyProfile && verification.bankInfo && verification.companyProfile.approve && verification.bankInfo.approve && d.shop.active)
											}).length
										} 
										style={{ 
											color: '#52c41a',
											borderColor: '#52c41a', 
											backgroundColor: '#fff'
										}}
										showZero 
									/>
								</span>
							}
							key="verifiedActive" >
							
						</Tabs.TabPane>

						<Tabs.TabPane 
							tab={
								<span>
									Documents not Verified <Badge
										overflowCount={5000} 
										count={data.filter(d => {
												const { verification } = d;
												return (verification && verification.companyProfile && verification.bankInfo && !verification.companyProfile.approve && !verification.bankInfo.approve && verification.companyProfile.document && verification.bankInfo.document)
											}).length
										} 
										style={{ 
											color: '#f5222d',
											borderColor: '#f5222d', 
											backgroundColor: '#fff'
										}}
										showZero 
									/>
								</span>
							}
							key="notVerified" >
							
						</Tabs.TabPane>
						<Tabs.TabPane 
							tab={
								<span>
									No documents <Badge
										overflowCount={5000} 
										count={data.filter( d => {
												const { verification } = d;
												return (!verification || !verification.companyProfile || !verification.bankInfo || !verification.companyProfile.document || !verification.bankInfo.document);
											}).length} 
										style={{ 
											color: '#f5222d',
											borderColor: '#f5222d', 
											backgroundColor: '#fff'
										}}
										showZero 
									/>
								</span>
							}
							key="docsNotSubmitted" >
						</Tabs.TabPane>
						<Tabs.TabPane 
							tab={
								<span>
									Disabled <Badge
										overflowCount={5000} 
										count={data.filter( d => !d.shop || !d.shop.active).length} 
										style={{ 
											color: '#f5222d',
											borderColor: '#f5222d', 
											backgroundColor: '#fff'
										}}
										showZero 
									/>
								</span>
							}
							key="disabledShops">
						</Tabs.TabPane>
						<Tabs.TabPane 
							tab={
								<span>
									Flagged For Delete <Badge
										overflowCount={5000} 
										count={data.filter( d => d.flaggedForDelete).length} 
										style={{ 
											color: '#f5222d',
											borderColor: '#f5222d', 
											backgroundColor: '#fff'
										}}
										showZero 
									/>
								</span>
							}
							key="flaggedForDelete">
						</Tabs.TabPane>
					</Tabs>
	
					<Table dataSource={_data}
						rowKey='_id'
						locale={{ emptyText: `Can't find suppliers matching "${filter}"` }}
					>
						
						<Column 
							title="Company Name" 
							dataIndex="details.companyName"
							// filteredValue="detais.companyName"
							// onFilter={(filter, record) => console.log(record, filter, this.state)}
							/>
						
						<Column 
							title="Contact Person" 
							dataIndex="details.name"
							/>
	
						<Column
							title="Handphone"
							dataIndex="details.hp"/>
	
						<Column 
							title="Email"
							dataIndex="details.email" />

						<Column 
							title="MOV" 
							dataIndex="shop.movFreeDelivery"
							render={ text => <div> {text? `$${text}`: null } </div>}
							/>

						<Column 
							title="Country" 
							dataIndex="shop.shopCountry"
							render={ text => <div> {text? `${text}`: null } </div>}
							/>
						
						<Column 
							title="Ghost"
							dataIndex="ghost"
							render={ text => <div>{text? 'Ghost' : ''}</div>}
							 />

						<Column 
							title="Flagged For Delete"
							dataIndex="flaggedForDelete"
							render={ text => <div>{text? 'True' : ''}</div>}
							 />

						<Column 
							title="Actions"
							dataIndex="_id"
							render={ text => <a target={`view_${text}`} href={`/supplier/${text}`}> View </a>}
							 />
	
					</Table>
				</Card>
			)
		}
	}

	constructor(props) {
		super(props);
		this.state = {
			//all, verifiedActive, notVerified, docsNotSubmitted, disabledShops
			activeFilterCategory: 'all',
			filter: '',
		}
	}
	
	updateFilterParam = ( searchParam ) => {

		this.setState({
			filter: searchParam
		})
		// console.log(filter)
	}

	updateFilter = ( key ) => {
		this.setState({
			activeFilterCategory: key
		})
	}

// 	onSearch = () => {
//     const { searchText } = this.state;
//     const reg = new RegExp(searchText, 'gi');
//     this.setState({
//       filterDropdownVisible: false,
//       filtered: !!searchText,
//       data: data.map((record) => {
//         const match = record.name.match(reg);
//         if (!match) {
//           return null;
//         }
//         return {
//           ...record,
//           name: (
//             <span>
//               {record.name.split(reg).map((text, i) => (
//                 i > 0 ? [<span className="highlight">{match[0]}</span>, text] : text
//               ))}
//             </span>
//           ),
//         };
//       }).filter(record => !!record),
//     });
//   }

}

export default SupplierTable;


// WEBPACK FOOTER //
// ./src/components/supplier/table.js